import { Model, Question, Serializer } from 'survey-core';
import addHours from 'date-fns/addHours';
import Modal from '../../components/Modal';
import { disableActionButton } from './CustomizeClass2MedDevSurveyAction';

Serializer.addProperty('question', {
  name: 'Class 2 Medical Device:boolean',
  category: 'general',
  default: false,
  visibleIndex: 0
});

export abstract class Class2MedDevModel extends Model {
  public skipConfirmation = false;

  // signals that the red flag outcome has been triggered.
  public redFlagOutcome = false;

  constructor(
    public user_guid: string,
    public case_id: number,
    public appt_id: number,
    public surveyjs_id: number,
    public getToken: () => Promise<string>,
    public vl_be: string
  ) {
    super();
  }

  public async handleRedFlagAction(question: Question, actionButton: HTMLButtonElement) {
    const { taskQueue, taskDeadlineInHours, taskNotes } = question.toJSON({ storeDefaults: true });
    const due_date_value = addHours(new Date(), taskDeadlineInHours);

    const onRedFlagTask = async () => {
      try {
        const response = await fetch(`${this.vl_be}/md/event`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: await this.getToken()
          },
          method: 'PUT',
          body: JSON.stringify({
            user_guid: this.user_guid,
            patient_guid: this.user_guid,
            case_id: this.case_id,
            task_type_code: 'RED-FLAG',
            description: taskNotes,
            due_date: due_date_value,
            // affected_user_guid: '',
            // assignee_user_guid: '',
            // appointmentId: this.appt_id,
            // survey_id: this.survey_id,
            hbs_task: taskQueue === 'Client queue' ? 0 : 1
          })
        });
        return response;
      } catch {
        return new Response('An error occurred', { status: 500 });
      }
    };

    Modal.confirm({
      title: 'Go to A&E',
      message:
        '<b>Are you sure you are happy to attend A&E?</b><br><br>We will call back tomorrow to confirm your treatment',
      onOk: async () => {
        const response = await onRedFlagTask();
        if (!response?.ok) {
          const error_text = await response?.text();
          console.log('Error:', error_text);
          Modal.error({
            title: 'Your survey upload failed',
            message: `
                <p>
                  An error has occurred while submitting your survey. If you need further assistance, please call us on 0115 857 3846.
                </p>
                <p>
                  If this is an emergency, please call 111 or go to A&E.
                </p>
                <details style="margin-top: 8px;">
                  <summary style="color: grey; cursor: pointer;">Technical Details</summary>
                  <pre style="white-space: pre-wrap; margin-top: 8px;">${error_text}</pre>
                </details>
              `,
            okText: 'OK'
          });

          return;
        }
        this.skipConfirmation = true;
        this.redFlagOutcome = true;
        disableActionButton(actionButton);
        this.completeLastPage();
      },
      okText: 'Yes, I will go to A&E',
      cancelText: "No, I've changed my mind"
    });
  }

  public abstract handleAction(question: Question, actionButton: HTMLButtonElement): Promise<void>;
}
